/* eslint-disable */
export const commonMixin = {
  data() {
    return {};
  },
  methods: {
    errorToast(err) {
      this.$snotify.error(err, "RealValues", {
        timeout: 3000,
        showProgressBar: false,
        position: "rightTop"
      });
    },
    getLocation() {
      // if (navigator.geolocation) {
      //   console.log(1);
      //   navigator.geolocation.getCurrentPosition(
      //     this.showPosition,
      //     this.handleLocationErr
      //   );
      // } else {
      //   console.log(2);
      //   this.handleLocationErr();
      // }
      if (
        typeof this.valuationSearch !== "undefined" &&
        (this.valuationSearch.distance != "" &&
          this.valuationSearch.latitude != "" &&
          this.valuationSearch.longitude != "")
      ) {
        this.myLatitude = this.valuationSearch.latitude;
        this.myLongitude = this.valuationSearch.longitude;
        this.getGeoRange();
      } else if (
        typeof this.search !== "undefined" &&
        (this.search.distance != "" &&
          this.search.latitude != "" &&
          this.search.longitude != "")
      ) {
        console.log("Lat: " + this.search.latitude);
        console.log("Long: " + this.search.longitude);
        this.myLatitude = this.search.latitude;
        this.myLongitude = this.search.longitude;
        console.log("Lat2: " + this.myLatitude);
        console.log("Long2: " + this.myLatitude);
        this.getGeoRange();
      }
    },
    showPosition(position) {
      this.myLatitude = position.coords.latitude;
      this.myLongitude = position.coords.longitude;
      this.getGeoRange();
    },
    fetchApi(url) {
      return fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          return json;
        });
    },
    handleLocationErr() {
      this.fetchApi("http://ip-api.com/json").then(result => {
        if (typeof result.zip !== "undefined" && result.zip != "") {
          this.fetchApi(
            "http://maps.googleapis.com/maps/api/geocode/json?address=" +
              result.zip
          ).then(res => {
            this.myLatitude = res.results[0].geometry.location.lat;
            this.myLongitude = res.results[0].geometry.location.lng;

            this.getGeoRange();
          });
        } else {
          this.myLatitude = result.lat;
          this.myLongitude = result.lon;
          this.getGeoRange();
        }
      });
    },
    getGeoRange() {
      let latitude = this.myLatitude;
      let longitude = this.myLongitude;
      if (
        typeof this.valuationSearch !== "undefined" &&
        (this.valuationSearch.distance != "" &&
          this.valuationSearch.latitude != "" &&
          this.valuationSearch.longitude != "")
      ) {
        console.log("Lat1: " + latitude);
        console.log("Long1: " + longitude);
        const geoRange = this.GeoLocation.boundingCoordinates(
          {
            degLat: latitude,
            degLon: longitude,
            radLat: this.GeoLocation.degreeToRadian(latitude),
            radLon: this.GeoLocation.degreeToRadian(longitude)
          },
          this.valuationSearch.distance
        );
        this.valuationSearch.minLat = geoRange.minLat;
        this.valuationSearch.maxLat = geoRange.maxLat;
        this.valuationSearch.minLon = geoRange.minLon;
        this.valuationSearch.maxLon = geoRange.maxLon;
      } else if (
        typeof this.search !== "undefined" &&
        (this.search.distance != "" &&
          this.search.latitude != "" &&
          this.search.longitude != "")
      ) {
        console.log("Lat2: " + latitude);
        console.log("Long2: " + longitude);
        const geoRange = this.GeoLocation.boundingCoordinates(
          {
            degLat: latitude,
            degLon: longitude,
            radLat: this.GeoLocation.degreeToRadian(latitude),
            radLon: this.GeoLocation.degreeToRadian(longitude)
          },
          this.search.distance
        );
        this.search.minLat = geoRange.minLat;
        this.search.maxLat = geoRange.maxLat;
        this.search.minLon = geoRange.minLon;
        this.search.maxLon = geoRange.maxLon;
      }
    },
    calculateFloorAreaFrom(obj) {
      const re = (obj.floor_area_from * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_area_from_sqf = re;
      }
    },
    reverseFloorAreaFrom(obj) {
      const re = (obj.floor_area_from_sqf / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_area_from = re;
      }
    },
    calculateFloorRateFrom(obj) {
      const re = (obj.floor_rate_from / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_rate_from_sqf = re;
      }
    },
    reverseFloorRateFrom(obj) {
      const re = (obj.floor_rate_from_sqf * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_rate_from = re;
      }
    },
    reverseFloorAreaTo(obj) {
      const re = (obj.floor_area_to_sqf / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_area_to = re;
      }
    },
    calculateFloorAreaTo(obj) {
      const re = (obj.floor_area_to * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_area_to_sqf = re;
      }
    },
    reverseFloorRateTo(obj) {
      const re = (obj.floor_rate_to_sqf * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_rate_to = re;
      }
    },
    calculateFloorRateTo(obj) {
      const re = (obj.floor_rate_to / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.floor_rate_to_sqf = re;
      }
    },
    calculateLandAreaFrom(obj) {
      const re = (obj.land_area_from * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_area_from_sqf = re;
      }
    },
    calculateLandAreaTo(obj) {
      const re = (obj.land_area_to * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_area_to_sqf = re;
      }
    },
    reverseLandAreaFrom(obj) {
      const re = (obj.land_area_from_sqf / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_area_from = re;
      }
    },
    reverseLandAreaTo(obj) {
      const re = (obj.land_area_to_sqf / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_area_to = re;
      }
    },
    calculateLandRateFrom(obj) {
      const re = (obj.land_rate_from / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_rate_from_sqf = re;
      }
    },
    calculateLandRateTo(obj) {
      const re = (obj.land_rate_to / 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_rate_to_sqf = re;
      }
    },
    reverseLandRateFrom(obj) {
      const re = (obj.land_rate_from_sqf * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_rate_from = re;
      }
    },
    reverseLandRateTo(obj) {
      const re = (obj.land_rate_to_sqf * 10.7639).toFixed(2);
      if (!isNaN(re)) {
        obj.land_rate_to = re;
      }
    },
    valuerEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=valuer&text=" + input;
      }
    },
    adminEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=admin&text=" + input;
      }
    },
    supervisorEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=supervisor&text=" + input;
      }
    },
    userEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=all&text=" + input;
      }
    },
    authHeaders() {
      return {
        Authorization: "Bearer " + this.$parent.token
      };
    },
    clearValuer(obj) {
      obj.valuer_user_id = "";
    },
    clearAdmin(obj) {
      obj.admin_user_id = "";
    },
    clearManager(obj) {
      obj.rm_customer_id = "";
    },
    formattedUserDisplay(result) {
      return result.name + " (" + result.email + " - " + result.code + ")";
    },
    customerEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "customer/fetch?text=" + input;
      }
    },
    formattedAddressDisplay(result) {
      return result.ADDRESS;
    },
    searchEndpoint(input) {
      return (
        process.env.VUE_APP_ADDRESS_API_URL +
        "?searchVal=" +
        input +
        "&returnGeom=Y&getAddrDetails=Y"
      );
    },
    getTenureType() {
      return this.$http
        .get(this.rootUrl + "config/tenure-type", this.corsConfig)
        .then(
          res => {
            this.refreshToken(res);
            this.tenureTypes = res.data || {
              config: []
            };
          },
          err => {
            this.errorToast(err.response.data.message);
          }
        );
    },
    clearRequester(obj) {
      obj.requestor_customer_id = "";
    },
    formattedCustomerDisplay(result) {
      return result.name + " (" + result.cust_ref_num + ")";
    },
    clearApplicant(obj) {
      obj.applicant_customer_id = "";
    },
    clearSearchValuer(obj) {
      obj.valuer_user_id = "";
    },
    clearSearchApplicant(obj) {
      obj.applicant_customer_id = "";
    },
    clearSearchManager(obj) {
      obj.rm_customer_id = "";
    },
    clearSearchLawyer(obj) {
      obj.lawyer_customer_id = "";
    },
    clearSearchBring(obj) {
      obj.bring_in_user_id = "";
    },
    clearSearchSupervisor(obj) {
      obj.supervisor_user_id = "";
    },
    clearSearchAdmin(obj) {
      obj.admin_user_id = "";
    },
    clearSearchRequester(obj) {
      obj.requestor_customer_id = "";
    },
    loadSummary(id) {
      this.$router.push({
        name: "valuation-summary",
        params: {
          id
        }
      });
    },
    goTo(route) {
      this.$router.push(route);
    },
    getPropertyType() {
      return this.$http
        .get(this.rootUrl + "config/property-type", this.corsConfig)
        .then(
          res => {
            this.refreshToken(res);
            this.propertyTypes = res.data || {
              config: []
            };
          },
          err => {
            this.errorToast(err.response.data.message);
          }
        );
    },
    changeSearchValuer($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchValuer(obj);
      }
    },
    changeSearchAdmin($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchAdmin(obj);
      }
    },
    changeSearchSupervisor($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchSupervisor(obj);
      }
    },
    changeSearchBring($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchBring(obj);
      }
    },
    changeSearchManager($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchManager(obj);
      }
    },
    changeSearchRequester($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchRequester(obj);
      }
    },
    changeSearchApplicant($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchApplicant(obj);
      }
    },
    changeSearchLawyer($e, obj) {
      if ($e.target.value == "") {
        this.clearSearchLawyer(obj);
      }
    },
    changeApplicant($e, obj) {
      if ($e.target.value == "") {
        this.clearApplicant(obj);
      }
    },
    changeRequester($e, obj) {
      if ($e.target.value == "") {
        this.clearRequester(obj);
      }
    },
    changeValuer($e, obj) {
      if ($e.target.value == "") {
        this.clearValuer(obj);
      }
    },
    clearAddress(obj) {
      obj.address = "";
      obj.latitude = "";
      obj.longitude = "";
    },
    changeAddress($e, obj) {
      if ($e.target.value == "") {
        this.clearAddress(obj);
      }
    },
    changeSupervisor($e, obj) {
      if ($e.target.value == "") {
        this.clearSupervisor(obj);
      }
    },
    clearSupervisor(obj) {
      obj.supervisor_user_id = "";
    },
    clearBring(obj) {
      obj.bring_in_user_id = "";
    },
    clearLawyer(obj) {
      obj.lawyer_customer_id = "";
    },
    changeAdmin($e, obj) {
      if ($e.target.value == "") {
        this.clearAdmin(obj);
      }
    },
    changeBring($e, obj) {
      if ($e.target.value == "") {
        this.clearBring(obj);
      }
    },
    changeManager($e, obj) {
      if ($e.target.value == "") {
        this.clearManager(obj);
      }
    },
    changeLawyer($e, obj) {
      if ($e.target.value == "") {
        this.clearLawyer(obj);
      }
    },
    // Get distinct address fields
    getDistinctAddress() {
      // load street name
      return this.$http.get(this.rootUrl + "street-name", this.corsConfig).then(
        res => {
          this.refreshToken(res);
          this.streetNames = res.data;
          this.streetNames = _.map(this.streetNames, "street_name");
          this.streetNames = _.uniq(_.compact(this.streetNames));
        },
        err => {
          this.errorToast(err.response.data.message);
        }
      );
    },
    // load project
    getDistinctProject() {
      return this.$http.get(this.rootUrl + "project", this.corsConfig).then(
        res => {
          this.refreshToken(res);
          this.projects = res.data;
          this.projects = _.map(this.projects, "project");
          this.projects = _.uniq(_.compact(this.projects));
        },
        err => {
          this.errorToast(err.response.data.message);
        }
      );
    },
    // load postal district
    getDistinctPostalDistrict() {
      return this.$http
        .get(this.rootUrl + "postal-district", this.corsConfig)
        .then(
          res => {
            this.refreshToken(res);
            this.postalDistricts = res.data;
            this.postalDistricts = _.map(
              this.postalDistricts,
              "postal_district"
            );
            this.postalDistricts = _.uniq(_.compact(this.postalDistricts));
          },
          err => {
            this.errorToast(err.response.data.message);
          }
        );
    },
    // load postal sector
    getDistinctPostalSector() {
      return this.$http
        .get(this.rootUrl + "postal-sector", this.corsConfig)
        .then(
          res => {
            this.refreshToken(res);
            this.postalSectors = res.data;
            this.postalSectors = _.map(this.postalSectors, "postal_sector");
            this.postalSectors = _.uniq(_.compact(this.postalSectors));
          },
          err => {
            this.errorToast(err.response.data.message);
          }
        );
    }
  }
};
